import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import RsvpSelect from '~/glm/components/shared/rsvp-dropdown-select';

const guestStatsStructure = [
  { color: '#9699A0', label: 'Not Invited', filterType: 'not invited' },
  { color: '#CACCD0', label: 'Invited', filterType: 'no response' },
  { color: '#58BF81', label: 'Attending', filterType: 'accepted' },
  { color: '#000000', label: 'Declined', filterType: 'declined' },
];

export default class RsvpStatusDropdown extends React.Component {
  static propTypes = {
    updateRsvpStatus: PropTypes.func,
    currentSelection: PropTypes.string,
    border: PropTypes.bool,
  };

  handleClick = selectionObj => {
    const { updateRsvpStatus } = this.props;
    const { label } = selectionObj;

    updateRsvpStatus(label);
  };

  render() {
    const { currentSelection, border = true } = this.props;

    return (
      <Fragment>
        {guestStatsStructure.map((structure, idx) => {
          const { color, label } = structure;
          return (
            <RsvpSelect
              key={idx}
              border={border}
              onClick={() => this.handleClick(structure)}
              color={color}
              label={label}
              selected={currentSelection === label}
            />
          );
        })}
      </Fragment>
    );
  }
}
